import React, {Fragment} from 'react';
import {Formik } from 'formik';
import {Grid} from '@material-ui/core';
import _ from 'lodash'
import moment from 'moment';
import styled from 'styled-components';
import {compose} from 'redux';
import { connect } from "react-redux";
import {DecimalInput,MoneyInput,DatePicker} from 'components/Global/FormikMaterial';
import {RadioInput} from 'components/Global/FastFormikMaterial';
import { AutoCompleteInput } from 'components/Global/FormikMaterial';
import { PrimaryButton, ButtonSizeOptions, SecondaryButton } from '@loanbossinc/component-library';
import WithoutQuoteFormVariant from './WithoutQuoteFormVariant';
import WithQuoteFormVariant from './WithQuoteFormVariant';
import InterestOnlyAmortVariant from './InterestOnlyAmortVariant';
import MortgageStyleAmortVariant from './MortgageStyleAmortVariant';
import {calculateSwapWithQuote, calculateSwapWithoutQuote} from 'store/state/calculators/bankSwap'
import {resetTestData} from 'store/state/calculators';
import {transformRate, transformBasisPoints} from 'utils/formTransformers';
import { shocks } from "../Constants/DropDownLists";
import {MARKET_EXPECTATIONS_SHOCK, PARALLEL_SHOCK, STANDARD_DEVIATION_SHOCK} from "../Constants/Constants";
const ParentGrid = styled(Grid)`  
  padding-left:15px;
`
const ButtonBar = styled(Grid)`
  && > *:first-child {
    margin-right: 12px;
  }
`
const VerticalSpacer = styled.div`
@media only screen and (max-width: 1920px) {
  height:15px;
}
@media only screen and (max-width: 1105px) {
  height:15px;
}
  width:100%;
`
const StyledDecimalInput = styled(DecimalInput)`
  & {width:100%;}
`

 const StyledLabel = styled.div `{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;


const WITHOUT_QUOTE = 'WITHOUT_QUOTE';
const WITH_QUOTE = 'WITH_QUOTE';
const calculationTypes = [{name: 'I need a quote', value: WITHOUT_QUOTE},{name: 'I have a quote', value: WITH_QUOTE}];

const INTEREST_ONLY = 'INTEREST_ONLY';
const MORTGAGE_STYLE = 'MORTGAGE_STYLE';
const amortizationTypes = [{name: 'Interest Only', value: INTEREST_ONLY}, {name: 'Mortgage Style', value: MORTGAGE_STYLE}]
class SwapCalculatorForm extends React.Component {
  state = {
  }
  
  componentDidMount(){
    if(this.props.swap != {}) {
      this.props.resetTestData();
    }
  }

  calculateSwap(calculationType, swapCalculationRequest){
    if(calculationType === WITHOUT_QUOTE)
      this.props.calculateSwapWithoutQuote(swapCalculationRequest);
    else
      this.props.calculateSwapWithQuote(swapCalculationRequest);
  }

  createSwapCalculationParameters(values) {
      let amortType = _.get(values, 'amortizationType');
      let params = {};
      
      params =  {
        loanAmount: _.get(values, 'loanAmount'),
        loanTerm: _.get(values, 'loanTerm'),
        spread: transformRate(_.get(values, 'spread')),
        startDate: moment(_.get(values, 'startDate')).format('YYYY-MM-DD'),
        swapAmortizationType: amortType
      };
      
      if(amortType === INTEREST_ONLY) {
        params.interestOnlyPeriod = null;
        params.amortizationTerm = null;
      } else {
        params.interestOnlyPeriod = _.get(values, 'interestOnlyPeriod');
        params.amortizationTerm = _.get(values, 'amortizationTerm');
      }
    
    this.setShock(values, params);
    
    if(_.get(values, 'calculationType') === WITHOUT_QUOTE){
      params.creditCharge = transformBasisPoints(_.get(values, 'creditCharge'))
    } else {
      params.allInRate = transformRate(_.get(values, 'allInRate'))
    }
    return params;
  }

  setShock(values, params){
    const shockScenario = _.get(values, 'shockScenario')    
    params.shockScenario = shockScenario;

    let shockValue = _.get(values, 'shockValue');
    if(shockScenario === PARALLEL_SHOCK)
      shockValue = shockValue / 10000;
    
    if(shockScenario !== MARKET_EXPECTATIONS_SHOCK)
      params.shockValue = shockValue;
  }
  doesUserNeedAQuote(values) {
    return _.get(values, 'calculationType') === WITHOUT_QUOTE;
  }

  isMortgageStyle(values) {
    return _.get(values, 'amortizationType') === MORTGAGE_STYLE;
  }

  showParallelShiftAmount(values) {
    return _.get(values, 'shockScenario') === PARALLEL_SHOCK;
  }
  
  standardDeviations(values) {
    return _.get(values, 'shockScenario') === STANDARD_DEVIATION_SHOCK;
  }

  renderShockScenarioDropdown = (formik) => {
    if(!this.props.authentication.isSystemAdmin){
      return null;
    }
    return (
      <Fragment>
    <p>Rate Environment</p>
      <AutoCompleteInput 
                      id="dropdownForShockScenario"
                      label="Shock Scenario"
                      fieldName="shockScenario"
                      selectValue="value"
                      options={shocks}
                      formik={formik}/>
      </Fragment>
    )
  }

  render(){
    
    let swapForm = {       
      calculationType: WITHOUT_QUOTE,
      amortizationType: INTEREST_ONLY,
      shockScenario: MARKET_EXPECTATIONS_SHOCK,
      shockValue: null      
     }
    return (
      <Formik 
      initialValues={swapForm}
      validateOnChange={false}
      validate={values => {                
        let errors ={}
        return errors;
      }}
      onSubmit={(values,{setSubmitting}) => {   
        let swapCalculationRequest = {};
        swapCalculationRequest = this.createSwapCalculationParameters(values);
        let calculationType = _.get(values, 'calculationType');
        this.calculateSwap(calculationType, swapCalculationRequest);
        setSubmitting(false);
      }}
      render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit,formik}) => (                            
          <ParentGrid container spacing={8}>
            <Grid container item xs={12} spacing={8}>
              <RadioInput 
                fullWidth
                label=""
                options={calculationTypes}
                fieldName="calculationType"/>
              <Grid item xs={12}></Grid>
              {this.doesUserNeedAQuote(values) && <WithoutQuoteFormVariant/>}
              {!this.doesUserNeedAQuote(values) && <WithQuoteFormVariant/>}          
              <Grid item xs={12} container spacing={8} alignItems="center">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <VerticalSpacer/>
                  <StyledLabel>Amortization Type</StyledLabel>
                </Grid>
                <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                  <RadioInput                 
                    label="Amortization Type"
                    options={amortizationTypes}
                    fieldName="amortizationType"/>
                  </Grid>
                  
                {!this.isMortgageStyle(values) && <InterestOnlyAmortVariant/>}
                {this.isMortgageStyle(values) && <MortgageStyleAmortVariant/>}

                  
              </Grid>
              
              <Grid container spacing={8} alignItems="center">
                <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                {this.renderShockScenarioDropdown(formik)}
                </Grid>

                <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                  {this.showParallelShiftAmount(values) && <StyledDecimalInput label="Parallel Shift Amount (bps)" fieldName="shockValue"/>}
                  {this.standardDeviations(values) && <StyledDecimalInput label="Standard Deviations" fieldName="shockValue"/>}
                </Grid> 

              </Grid>
            </Grid>            
            <ButtonBar item xs={12}>
              <PrimaryButton
                  style={{ marginRight: 24 }}
                  label="Calculate"
                  onClick={handleSubmit}
                  size={ButtonSizeOptions.smFluid}
                />                           
            </ButtonBar>          
          </ParentGrid>        
      )}/>
    );
}
}
function mapStateToProps({calculators,authentication}) {
  return {
    swap: calculators.bankSwap.swap,   
    authentication
  }
}

export default compose(
  connect(
    mapStateToProps,
    {      
      calculateSwapWithQuote,
      calculateSwapWithoutQuote,
      resetTestData
    }
  ))(SwapCalculatorForm);
